import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Remediation from './views/Remediation.vue'
import Alerts from './views/Alerts.vue'
import Vulnerabilities from './views/Vulnerabilities.vue'
import Profiles from './views/Profiles.vue'
import Settings from './views/Settings.vue'
import Account from './views/Account.vue'
import Accounts from './views/Accounts.vue'
import Assets from './views/Assets.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/remediation',
      name: 'remediation',
      component: Remediation
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: Alerts
    },
    {
      path: '/vulnerabilities',
      name: 'vunerabilities',
      component: Vulnerabilities
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: Profiles
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/account',
      name: 'account',
      component: Account
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: Accounts
    },
    {
      path: '/assets',
      name: 'assets',
      component: Assets
    },
  ]
})
